import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import OutsideClickHandler from "react-outside-click-handler";
import Moment from "moment";

import SessionContext from "../../../contexts/sessionContext";

import { FiFilter, FiPlus } from "react-icons/fi";

import { Container, Content } from "./styles";

import AddBackground from "../../../components/AddBackground";
import Register from "../../../components/Register";

import { list_users } from "../../../services/user";
import socket from "../../../services/socket";

import { UserType } from "../../../types/UserTypes";

function GerenciamentoCad() {
	const [sortType, setSortType] = useState<string>("");
	const [userList, setUserList] = useState<UserType[]>([]);

	const { user } = useContext(SessionContext);

	useEffect(() => {
		const sortArray = (type: string) => {
			const sorted = userList.sort((a, b) => {
				switch (type) {
					case "name":
						if (a.name.toLowerCase() < b.name.toLowerCase())
							return -1;
						else return 1;
					case "inversed-name":
						if (a.name.toLowerCase() > b.name.toLowerCase())
							return -1;
						else return 1;
					case "date":
						return a.createdAt > b.createdAt ? -1 : 1;
					case "inversed-date":
						return a.createdAt < b.createdAt ? -1 : 1;
					case "status":
						return a.status ? -1 : 1;
					case "inversed-status":
						return !a.status ? -1 : 1;
					case "role":
						return a.role - b.role;
					case "inversed-role":
						return b.role - a.role;
					default:
						return 0;
				}
			});

			setUserList(sorted);
		};

		sortArray(sortType);
	}, [sortType, userList]);

	const request_users = async () => {
		const users = await list_users();

		setUserList(users!);
	};

	useEffect(() => {
		request_users();
	}, []);

	socket.on("user:status", (user: any) => {
		setUserList((state) =>
			state.map((userList) =>
				userList.id === user.id
					? { ...userList, status: user?.status }
					: userList,
			),
		);
	});

	const [register, setRegister] = useState("hidden");

	const EmploCard = (userData: any) => {
		function splitString(string: any) {
			const arrayName = string.split(" ");
			const twoName = arrayName.slice(0, 2);
			const name = twoName.join(" ");

			return name;
		}

		const name = splitString(userData.name);

		return (
			<tr className='tr-wrapper'>
				<td className='process-text' id='name'>
					{name}
				</td>
				<td className='process-text' id='date'>
					{userData.createdAt}
				</td>
				<td className='process-text' id='mail'>
					{userData.email}
				</td>
				<td>
					<div
						className={`status ${
							userData.status === true ? "online" : "offline"
						}`}>
						{userData.status === true ? "Online" : "Off"}
					</div>
				</td>
				<td className='process-text'>
					{userData.role === 0
						? "Administrador"
						: userData.role === 1
						? "Analista"
						: "Digitador"}
				</td>
			</tr>
		);
	};

	const handleAddUser = async () => {
		try {
			request_users();
			setRegister("hidden");
		} catch (error) {
			return error;
		}
	};

	return (
		<Container>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					height: "2rem",
					gap: "0.5rem",
				}}>
				<p id='header'>Administrador</p>
				<span>{user.name}</span>
			</div>
			<Content>
				<div className='left-side'>
					<div className='content' id='process-manager'>
						<p id='header'>Gerenciamento de Cadastros</p>
						<table
							className='process-wrapper'
							style={{ position: "relative" }}>
							<tr className='tr-wrapper' id='tr-title'>
								<th>Nome</th>
								<th>Data de criação</th>
								<th>E-mail</th>
								<th>Status</th>
								<th>Cargo</th>
							</tr>

							{userList
								? userList.map((item) => {
										return (
											<Link
												to={{
													pathname: `/gerenciamento-de-cadastro/user&id=${item.id}`,
												}}>
												<EmploCard
													name={item.name}
													createdAt={Moment(
														item.createdAt,
													).format("DD/MM/YYYY")}
													email={item.email}
													status={item.status}
													role={item.role}
													id={item.id}
													key={item.id}
												/>
											</Link>
										);
								  })
								: null}
						</table>
					</div>
				</div>

				<div className='right-side'>
					<div className='content' id='create-user-container'>
						<button
							className='create-user'
							onClick={() => setRegister("show")}>
							Criar usuário <FiPlus id='icon' />
						</button>
					</div>

					<div className='content' id='filter'>
						<div className='filter-header'>
							<FiFilter id='icon' />
							<p className='filter-text'>Filtro</p>
						</div>
						<button
							className='filter-button'
							onClick={() =>
								setSortType(
									sortType === "name"
										? "inversed-name"
										: "name",
								)
							}>
							Nome
						</button>
						<button
							className='filter-button'
							onClick={() =>
								setSortType(
									sortType === "date"
										? "inversed-date"
										: "date",
								)
							}>
							Data de Criação
						</button>
						<button
							className='filter-button'
							onClick={() =>
								setSortType(
									sortType === "status"
										? "inversed-status"
										: "status",
								)
							}>
							Status
						</button>
						<button
							className='filter-button'
							onClick={() =>
								setSortType(
									sortType === "role"
										? "inversed-role"
										: "role",
								)
							}>
							Cargo
						</button>
					</div>
				</div>
			</Content>

			<AddBackground className={register}>
				<OutsideClickHandler
					onOutsideClick={() => setRegister("hidden")}>
					<Register show={setRegister} afterSubmit={handleAddUser} />
				</OutsideClickHandler>
			</AddBackground>
		</Container>
	);
}

export default GerenciamentoCad;
